const startCarousel = () => {
	const carousel = document.querySelector('article.carousel')

	if (carousel) {
		let current = carousel.querySelector('.items > *')
		const left = carousel.querySelector('.scroll-button.left')
		const right = carousel.querySelector('.scroll-button.right')

		// marker group logic
		const options = {
			root: carousel.querySelector('.items'),
			rootMargin: "0px",
			threshold: 0.5
		}

		const callback = (entries, observer) => {
			entries.forEach(entry => {
				const id = entry.target.dataset.id
				const marker = carousel.querySelector(`.scroll-marker-group [data-id="${id}"]`)

				if (entry.isIntersecting) {
					current = entry.target
					marker.classList.add('target-current')

					if (!current.previousElementSibling) {
						left.disabled = true
					} else {
						left.disabled = false
					}

					if (!current.nextElementSibling) {
						right.disabled = true
					} else {
						right.disabled = false
					}

				} else {
					marker.classList.remove('target-current')
				}
			})
		}

		const observer = new IntersectionObserver(callback, options)
		const items = document.querySelectorAll('.items > *')

		items.forEach(item => observer.observe(item))

		// scroll button logic
		left.addEventListener('click', () => {
			current.previousElementSibling?.scrollIntoView()
		})

		right.addEventListener('click', () => {
			current.nextElementSibling?.scrollIntoView()
		})
	}
}

startCarousel()
